// Meat industry tokens. Mahogany red primary, warm gold accent, cream
// surfaces (no dark backgrounds), Manrope for headings and UI.
import { baseTokens } from '../_base/tokens.js';

export const meatTokens = {
  ...baseTokens,
  token: {
    ...baseTokens.token,
    colorPrimary: '#e53935',
    colorInfo: '#e53935',
    colorLink: '#e53935',
    colorPrimaryHover: '#d32f2f',
    colorLinkHover: '#b71c1c',
    colorPrimaryActive: '#b71c1c',
    colorWarning: '#f97316',
    colorSuccess: '#2f7d4f',
    borderRadius: 8,
    fontFamily:
      "'Manrope', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue', Arial, sans-serif",
  },
  components: {
    ...baseTokens.components,
    Button: { borderRadius: 8, fontWeight: 600 },
    Card: { borderRadiusLG: 12 },
  },
};
